module.exports = __webpack_public_path__ + "img/40_69_009_370.d4501094.jpg";